import { defineComponent, h } from 'vue';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';
import PropertyGrid from './PropertyGrid.jsx';
import TranslationContainer from '../TranslationContainer.jsx';

export default defineComponent({
    name: 'hsm-statement-schema',
    components: {
        PropertyGrid,
        TranslationContainer,
    },
    data: function () {
        return {
            condition_expn: null,
            control_schema: null,
        };
    },
    created() {
        this.watcher$ = this.$watch('cmodel.StatementName', function () {
            this.Refresh();
        });
    },
    unmounted() {
        if (this.watcher$) this.watcher$();
    },
    mounted() {
        this.Refresh();
    },
    computed: {
        ...utils.forms.computed,
    },
    methods: {
        ...methods,
        Refresh() {
            const c = this.FindDesignerChildHsmStatement(this.cmodel.StatementName);
            if (c) {
                this.control_schema = {
                    type: 'object',
                    properties: c.ControlData.Arguments,
                };
            }
        },
    },
    props: {
        name: '',
        schemakey: '',
        root: null,
        schema: null,
        cmodel: null,
        extra: null,
        readonly: false,
        child: 0,
        navigateToModel: null,
        propertygrid: false,
    },
    render() {
        let desc;
        if (this.schema.description)
            desc = (
                <i
                    class="mdi mdi-information"
                    title={this.schema.description}
                    style={{ color: 'var(--v-checkboxGrey-base)', fontSize: 'small', marginLeft: '3px' }}
                ></i>
            );

        if (!this.cmodel.Arguments) this.cmodel.Arguments = {};

        const name = <span style={{ marginLeft: this.child * 15 + 'px' }}>{this.name}</span>;
        let form;
        if (this.control_schema) {
            form = (
                <PropertyGrid
                    name="hsmStatement"
                    root={this.root}
                    schema={this.control_schema}
                    form={['*']}
                    cmodel={this.cmodel.Arguments}
                    child={0}
                    navigateToModel={this.root?.navigateToModel || this.navigateToModel}
                ></PropertyGrid>
            );
        } else form = <TranslationContainer context={this} value={'Loading...'} />;

        return (
            <tr>
                <td style={{ width: '1px', verticalAlign: 'top' }}>
                    {name} {desc}
                </td>
                <td
                    class={{ 'property-grid': this.propertygrid }}
                    style={this.propertygrid ? { minWidth: 0 } : undefined}
                >
                    {form}
                </td>
            </tr>
        );
    },
});
